// extracted by mini-css-extract-plugin
export default {"container":"PieceRendererCurrentPlayedNote_container__gZ2JT","pitchTitle":"PieceRendererCurrentPlayedNote_pitchTitle__yrksv"};